import styled from "styled-components"
import { 
    // COLOR,
    // FONT
 } from 'assets'
 
export const CreatorProfileContainerStyled = styled.div`
/*===============================================
 Container 
===============================================*/
    
/*===============================================
Theme 
===============================================*/
  
`